export default __webpack_public_path__ + "static/media/bussolar2.1e7c2f30.jpeg";